export class Document {
	public id: string;
	public title: string;
	public pageCount: number;
	public extension: string;
	public batesStartPageStamp: string;
	public batesEndPageStamp: string;
}
